let hydratingFromPreloadedState = false;

export function getPreloadedState() {
    const preloadedState = window.__PRELOADED_STATE__;
    delete window.__PRELOADED_STATE__;
    hydratingFromPreloadedState = !!preloadedState;
    return preloadedState;
}

// True only once, on the first client render after SSR: the route data is already in the preloaded state.
export function consumeHydrationFlag() {
    const hydrating = hydratingFromPreloadedState;
    hydratingFromPreloadedState = false;
    return hydrating;
}

export function getPreloadedI18n() {
    const preloadedI18n = typeof window !== 'undefined' ? window.__PRELOADED_I18N__ : null;
    if (typeof window !== 'undefined') {
        delete window.__PRELOADED_I18N__;
    }
    return preloadedI18n;
}

export function isEntityLoaded(entity, id) {
    return !!entity && id !== null && id !== undefined && `${entity.id}` === `${id}`;
}
